import React, { Component, Fragment } from 'react';
import { action, computed, observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import moment from 'moment';

import withAppStore from 'decorators/withAppStore';

import Drawer from 'material-ui/Drawer';
import Select from 'material-ui/Select';
import { InputLabel } from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import { MenuItem } from 'material-ui/Menu';
import { FormControl } from 'material-ui/Form';
import { DatePicker } from 'material-ui-pickers';
import { FormControlLabel } from 'material-ui/Form';
import Switch from 'material-ui/Switch';
import { ChevronLeft, ChevronRight } from 'mdi-material-ui';

import styles from 'styles/components/SettingsDrawer';

import { KIND, THEME, TYPE, CLOSE_TYPE } from '-enums';
import { MIN_DATE, MAX_DATE, DISPLAY_DATE_FORMAT, TRANSPORT_DATE_FORMAT } from 'shared/config/widget';

@withStyles(styles)
@withAppStore
@observer
export default class SettingsDrawer extends Component {

  @observable code = '';

  @computed
  get dateValue() {
    const { date } = this.appStore;
    return date ? moment(date, TRANSPORT_DATE_FORMAT) : null;
  }

  componentDidMount() {
    reaction(
      () => this.code,
      code => this.appStore.code = code,
      {
        delay: 500
      }
    );
    reaction(
      () => this.appStore.code,
      code => this.code = code
    )
  }

  render() {
    const { classes } = this.props;

    return (
      <Drawer
        type="permanent"
        anchor='right'
        classes={{ paper: classes.root }}
      >

        <div className={ classes.form }>

          <FormControl >
            <InputLabel htmlFor="kind">Тип виджета</InputLabel>
            <Select
              value={ this.appStore.kind }
              onChange={ this.handleKindChange }
              inputProps={{
                name: 'kind',
                id: 'kind',
              }}
            >
              <MenuItem value={ KIND.TREE }>Дерево</MenuItem>
              <MenuItem value={ KIND.INFO }>Справка</MenuItem>
            </Select>
          </FormControl>

          <FormControl >
            <InputLabel htmlFor="theme">Тема</InputLabel>
            <Select
              value={ this.appStore.theme }
              onChange={ this.handleThemeChange }
              inputProps={{
                name: 'theme',
                id: 'theme',
              }}
            >
              <MenuItem value={ THEME.LIGHT }>Светлая</MenuItem>
              <MenuItem value={ THEME.DARK }>Темная</MenuItem>
            </Select>
          </FormControl>

          <TextField
            id="code"
            label="Код"
            value={ this.code || '' }
            onChange={ this.handleCodeChange }
            margin="none"
          />

          { this.appStore.isTree &&

            <FormControl >
              <InputLabel htmlFor="type">Каталог</InputLabel>
              <Select
                value={ this.appStore.type }
                onChange={ this.handleTypeChange }
                inputProps={{
                  name: 'type',
                  id: 'type',
                }}
              >
                <MenuItem value={ TYPE.TNVED }>ТН ВЭД</MenuItem>
                <MenuItem value={ TYPE.GNG } disabled={ !this.appStore.isTree }>ГНГ</MenuItem>
                <MenuItem value={ TYPE.ETSNG } disabled={ !this.appStore.isTree }>ЕТСНГ</MenuItem>
              </Select>
            </FormControl>

          }

          <DatePicker
            value={ this.dateValue }
            format={ DISPLAY_DATE_FORMAT }
            autoOk={ true }
            emptyLabel='На дату'
            cancelLabel='Отмена'
            clearLabel='Сброс'
            clearable={ true }
            onChange={ this.handleDateChange }
            openToYearSelection= { !this.appStore.date }
            minDate={ MIN_DATE }
            maxDate={ MAX_DATE }
            leftArrowIcon={ <ChevronLeft /> }
            rightArrowIcon={ <ChevronRight /> }
          />

          <FormControlLabel
            control={
              <Switch
                checked={ this.appStore.dominantMode }
                onChange={ this.handleDominantModeChange }
              />
            }
            label="Доминантный режим"
          />

          { this.appStore.dominantMode &&
            <TextField
              label="Идентификатор виджета"
              value={ this.appStore.widgetId || '' }
              onChange={ this.handleWidgetIdChange }
              margin="none"
            />
          }

          <FormControlLabel
            control={
              <Switch
                checked={ this.appStore.fullWidth }
                onChange={ this.handleFullWidthChange }
              />
            }
            label="По ширине страницы"
          />

          <FormControlLabel
            control={
              <Switch
                checked={ this.appStore.fullHeight }
                onChange={ this.handleFullHeightChange }
              />
            }
            label="По высоте страницы"
          />

          { this.appStore.isTree ? (
            <Fragment>

              <FormControlLabel
                control={
                  <Switch
                    checked={ this.appStore.dense }
                    onChange={ this.handleDenseChange }
                  />
                }
                label="Компактный вид"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={ this.appStore.searchOpen }
                    onChange={ this.handleSearchOpenChange }
                  />
                }
                label="Открыть поиск"
              />

              <TextField
                id="searchTerm"
                label="Текст для поиска"
                value={ this.appStore.searchTerm }
                onChange={ this.handleSearchTermChange }
                margin="none"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={ this.appStore.disableInfo }
                    onChange={ this.handleDisableInfoChange }
                  />
                }
                label="Отключить справку"
              />

              <FormControl >
                <InputLabel htmlFor="closeType">Тип закрытия окон</InputLabel>
                <Select
                  value={ this.appStore.closeType }
                  onChange={ this.handleCloseTypeChange }
                  inputProps={{
                    name: 'closeType',
                    id: 'closeType',
                  }}
                >
                  <MenuItem value={ CLOSE_TYPE.CLOSE }>Закрыть</MenuItem>
                  <MenuItem value={ CLOSE_TYPE.BACK }>Назад</MenuItem>
                </Select>
              </FormControl>

            </Fragment>
          ) : (
            <Fragment>

              <FormControlLabel
                control={
                  <Switch
                    checked={ this.appStore.showTitle }
                    onChange={ this.handleShowTitleChange }
                  />
                }
                label="Показывать заголовок"
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={ this.appStore.collapsed }
                    onChange={ this.handleCollapsedChange }
                  />
                }
                label="Показывать свернутыми"
              />

            </Fragment>
          )}

        </div>

      </Drawer>

    );
  }

  @action.bound
  handleKindChange({ target: { value } }) {
    this.appStore.kind = value;
  }

  @action.bound
  handleThemeChange({ target: { value } }) {
    this.appStore.theme = value;
  }

  @action.bound
  handleCodeChange({ target: { value } }) {
    this.code = value;
  }

  @action.bound
  handleTypeChange({ target: { value } }) {
    this.appStore.type = value;
  }

  @action.bound
  handleDateChange(value) {
    this.appStore.date = value ? value.format(TRANSPORT_DATE_FORMAT) : null;
  }

  @action.bound
  handleDominantModeChange(event, checked) {
    this.appStore.dominantMode = checked;
  }

  @action.bound
  handleWidgetIdChange({ target: { value } }) {
    this.appStore.widgetId = value;
  }

  @action.bound
  handleFullHeightChange(event, checked) {
    this.appStore.fullHeight = checked;
  }

  @action.bound
  handleFullWidthChange(event, checked) {
    this.appStore.fullWidth = checked;
  }

  @action.bound
  handleDenseChange(event, checked) {
    this.appStore.dense = checked;
  }

  @action.bound
  handleShowTitleChange(event, checked) {
    this.appStore.showTitle = checked;
  }

  @action.bound
  handleCollapsedChange(event, checked) {
    this.appStore.collapsed = checked;
  }

  @action.bound
  handleSearchOpenChange(event, checked) {
    this.appStore.searchOpen = checked;
  }

  @action.bound
  handleSearchTermChange({ target: { value } }) {
    this.appStore.searchTerm = value;
  }

  @action.bound
  handleDisableInfoChange(event, checked) {
    this.appStore.disableInfo = checked;
  }

  @action.bound
  handleCloseTypeChange({ target: { value } }) {
    this.appStore.closeType = value;
  }

}



// WEBPACK FOOTER //
// ./src/components/SettingsDrawer.js